import { css } from '@/styled-system/css';

export const managerName = css({
  fontSize: 'body-sm',
  fontWeight: 'bold',
  color: 'text.neutral',
  marginBottom: 'tightest',
});

export const companyName = css({
  fontSize: 'body-sm',
  color: 'text.subtle',
  marginBottom: 'tightest',
});

export const verifiedBadge = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tighter',
  fontSize: 'body-sm',
  color: 'text.express.trust.hero',
  marginBottom: 'default',
});

export const verifiedIcon = css({
  width: '400',
  height: '400',
  color: 'icon.express.trust.hero',
});

export const officeHours = css({
  fontSize: 'body-sm',
  color: 'text.subtle',
});

export const officeHoursLabel = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tighter',
  fontWeight: 'bold',
  color: 'text.neutral',
  marginBottom: 'tightest',
});

export const officeHoursList = css({
  display: 'grid',
  gridTemplateColumns: 'max-content max-content',
  alignItems: 'baseline',
  columnGap: 'tighter',
  rowGap: 'tightest',
  margin: 0,
  overflowX: 'auto',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

export const officeHoursText = css.raw({
  whiteSpace: 'nowrap',
});

export const officeHoursDescriptionText = css.raw({
  margin: 0,
  whiteSpace: 'nowrap',
});

export const officeHoursUnstructuredText = css.raw({
  margin: 0,
  overflowX: 'auto',
  scrollbarWidth: 'none',
  whiteSpace: 'nowrap',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

export const managerIcon = css({
  width: '400',
  height: '400',
});

export const desktopContactSection = css({
  display: 'block',
  marginBottom: 'default',
});

export const desktopContactLabel = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tighter',
  fontWeight: 'bold',
  fontSize: 'body-sm',
  color: 'text.neutral',
  marginBottom: 'tightest',
});

export const desktopContactIcon = css({
  display: 'flex',
  color: 'text.neutral',
  '& svg': {
    width: '400',
    height: '400',
  },
});

export const desktopContactPhone = css({
  display: 'block',
  fontSize: 'body-sm',
  color: 'brand.primary',
  textDecoration: 'none',
  _hover: {
    textDecoration: 'underline',
  },
  _focus: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'brand.primary',
    outlineOffset: '50',
  },
});

export const footerActions = css({
  display: 'flex',
  gap: 'tighter',
  width: '100%',
  marginTop: 'default',
});

export const messageButtonWrapper = css({
  flex: 1,
  lg: {
    maxWidth: '50%',
  },
});

export const callButtonWrapper = css({
  flex: 1,
  display: 'flex',
  lg: {
    display: 'none',
  },
});
